// extracted by mini-css-extract-plugin
module.exports = {"exception":"_3dQMI","imgBlock":"VzkS_","imgEle":"_1zz9C","content":"_-6DJH","desc":"_2ROXV","actions":"_1cgdt"};